import { render, staticRenderFns } from "./zhaohui.vue?vue&type=template&id=2830aa81&scoped=true"
import script from "./zhaohui.vue?vue&type=script&lang=js"
export * from "./zhaohui.vue?vue&type=script&lang=js"
import style0 from "./zhaohui.vue?vue&type=style&index=0&id=2830aa81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830aa81",
  null
  
)

export default component.exports